module.exports = __webpack_public_path__ + "static/edit-language-welcome-text-dac67afeff572bf15ee107afcc5976d8.png";